<template>
  <div v-if="msg" :data-id="msg.id.value" :class="leftRight">
    <div class="message-item" :class="messageType">
      <div class="message-item__avatar" v-if="mode != 'bot' && !candidateMsg">
        <Avatar
          :size="40"
          :fullName="msg.assigned_user_name ? msg.assigned_user_name : ''"
        />
      </div>
      <div class="message-item__container">
        <div class="message-container">
          <div v-if="isEmail" class="message-item__email-info">
            <div class="message-item__addressees">
              <p class="message-item__addressees--left">От</p>
              <p class="message-item__addressees--right">{{ emailFrom }}</p>

              <FormButtons
                v-if="
                  isEmail && msg.answer_buttons && msg.answer_buttons.length
                "
                :buttons_menu="[msg.answer_buttons]"
                topPanel
                view-type="detail"
                :disabled="!!emails.length"
                class="message-item__actions"
              />
            </div>

            <div class="message-item__addressees">
              <p class="message-item__addressees--left">Кому</p>
              <p class="message-item__addressees--right">
                {{ msg.to_addrs_names || '[email не указан]' }}
              </p>
            </div>
          </div>
          <div
            :ref="`msg-${msg.id}`"
            :class="[
              'message-item__text',
              visibleTextHelp ? 'message-item__with-help' : '',
              isFullText ? 'message-item__text_height_full' : ''
            ]"
          >
            <div
              class="message-item__theme"
              v-if="msg.name && isEmail"
              v-html="msg.name"
              @click="messageLink(msg.id)"
            ></div>
            <div
              v-html="isFullText ? msgText + '<br>' + '<br>' + '<br>' : msgText"
              class="message-item__description primary"
              :class="[isFullText ? '' : 'message-item__description--short']"
            ></div>
            <span
              v-if="visibleTextHelp"
              class="message-item__show-more blue fw-500"
              @click="isFullText = !isFullText"
            >
              {{ isFullText ? 'Закрыть' : 'Раскрыть' }}
              <Icon iconName="SmallArrowDown" iconColor="#0075DB" />
            </span>
          </div>

          <div class="message-item__info">
            {{
              `${msg.type_channel}, ${
                msg.type == 'Входящее'
                  ? msg.date_sent_received
                  : msg.date_entered
              }`
            }}
          </div>
        </div>
        <div v-if="hasAttachment.length" class="message-attachment">
          <MessageAttachment
            v-for="file in hasAttachment"
            :key="file.id || file.name"
            :file="file"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '@/store';
import { mixin, dialogMixin, errorMsg } from '@/utils/mixins';
import MessageAttachment from 'Elements/Messenger/MessageAttachment';
import Avatar from 'Elements/Avatar/Avatar';
import FormButtons from 'Elements/Form/FormButtons';
import Icon from 'Elements/Icon/Icon';

export default {
  mixins: [mixin, dialogMixin, errorMsg],
  props: {
    mode: {
      type: String,
      default: ''
    },
    msg: {
      type: Object,
      default() {
        return {};
      }
    },
    emails: {
      type: Array,
      default() {
        return [];
      }
    },
    id: String,
    name: String
  },
  data() {
    return {
      isFullText: false,
      visibleTextHelp: false
    };
  },
  mounted() {
    this.visibleTextHelp = this.visibleTextElem;
  },
  computed: {
    botMsg() {
      return this.isWhatsApp && this.recruiterMesg; //|| this.msg.bot;
    },
    isEmail() {
      return this.msg.type_channel == 'Email';
    },
    isTelegram() {
      return this.msg.type_channel == 'Telegram';
    },
    isWhatsApp() {
      return this.msg.type_channel == 'WhatsApp';
    },

    candidateMsg() {
      return (
        (this.isTelegram && !Number(this.msg.is_out)) ||
        (this.isEmail && this.msg.type == 'Входящее') ||
        (this.isWhatsApp && this.msg.type == 'Входящее') ||
        (this.mode == 'bot' && this.msg.type_messages == 'in')
      );
    },
    msgText() {
      return (
        this.formatHtml(this.msg.description_html_subpanel) ||
        this.msg.description_subpanel ||
        this.msg.description ||
        '[текст сообщения отсутствует]'
      ).replace(/(\r\n)|(\n)/gi, '<br/>');
    },
    visibleTextElem() {
      return (
        this.$refs[`msg-${this.msg.id}`].offsetHeight == 136 && !this.isFullText
      );
    },
    messageType: function () {
      return this.isEmail ? 'email' : 'message';
    },
    leftRight: function () {
      return this.candidateMsg ? '' : 'message-item__right';
    },
    author() {
      return (
        (this.candidateMsg ? this.name : this.msg.assigned_user_name) ||
        (this.botMsg ? 'Чат бот' : '[нет имени]')
      );
    },
    avatar() {
      return this.candidateMsg
        ? `/index.php?entryPoint=download&id=${this.id}_photo&type=HRPAC_CANDIDATES`
        : `/index.php?entryPoint=download&id=${this.msg.assigned_user_id}_photo&type=Users`;
    },
    emailFrom() {
      const email = this.msg.from_addr_name;
      return email && email !== 'null' ? email : '[email не указан]';
    },
    hasAttachment() {
      const file = this.msg?.filename;
      return file && file !== 'unknown_file'
        ? Array.isArray(file)
          ? file
          : [{ name: file }]
        : [];
    },
    noEmailSettings() {
      return store.state.common.notifications.send_mail;
    }
  },
  methods: {
    messageLink(id) {
      this.$router.push({
        name: '*',
        params: {
          url: `index.php?module=Emails&action=DetailView&record=${id}`
        }
      });
    },
    async handleCommand(command) {
      if (this.noEmailSettings) {
        this.showErrorMessage(this.noEmailSettings);
        return;
      }

      store.commit('subpanels/setSelectedMessage', {
        action: command.id,
        msg: this.msg
      });
      this.setVisibleDialog('send_mail_dialog', true);
    }
  },
  components: {
    MessageAttachment,
    Avatar,
    Icon,
    FormButtons
  }
};
</script>

<style lang="scss" scoped>
.message-item {
  &__actions {
    & ::v-deep .el-dropdown-selfdefine {
      .content-icon {
        filter: $greyPicture;
      }
    }
  }
}
</style>

<style lang="scss">
.message-item {
  display: flex;
  flex-direction: row;
  text-align: left;
  margin-bottom: 16px;

  &__actions {
    width: unset !important;

    & ::v-deep .el-dropdown-selfdefine {
      .content-icon {
        filter: $greyPicture;
      }
    }
  }

  &__container {
    max-width: 552px;
  }

  p,
  span {
    font-size: 14px;
    line-height: 20px;
  }

  .message-item__show-more {
    padding: 12px 0 4px 0;
    font-size: 16px;
    line-height: 16px;
    height: 24px;

    &:before {
      display: none;
    }
  }

  &__avatar {
    width: 48px;
    padding-right: 8px;
  }

  &__right {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  &__email-info {
    padding-bottom: 8px;
    margin-bottom: 8px;
    border-bottom: 1px solid $grey12;
  }

  &__addressees {
    display: flex;
    width: 100%;
    flex-direction: row;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;

    &--left {
      color: $grey24;
      width: 57px;
    }

    &--right {
      color: $grey64;
      width: calc(100% - 57px - 24px);
      padding-right: 4px;
    }
  }

  &__text {
    word-break: break-word;
    overflow: hidden;
    position: relative;
    // padding-bottom: 12px;
    background-color: inherit;
    font-size: 15px;
    line-height: 24px;
    max-height: 136px;

    &_height_full {
      max-height: unset;
      overflow: unset;

      .message-item__show-more {
        svg {
          transform: rotate(180deg);
        }
      }
    }
  }

  &__description {
    &_short {
      overflow: hidden;
      font-size: 15px;
      line-height: 24px;
      word-break: break-word;
    }

    * {
      background-color: inherit !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden;
      white-space: normal;
      max-width: 100% !important;
      font-size: 15px;
    }
  }

  &__show-more {
    display: flex;
    align-items: center;
    color: $blue-120;
    font-size: 16px;
    line-height: 24px;
    cursor: pointer;
    padding: 4px 0 8px 0;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: inherit;

    &:before {
      content: '';
      display: block;
      height: 10px;
      width: 100%;
      position: absolute;
      top: -9px;
      background: linear-gradient(0deg, $white, transparent);
    }

    svg {
      transition: all 0.5s;
    }
  }

  &__theme {
    margin-bottom: 8px;
    font-weight: bold;
    font-size: 15px;
    line-height: 24px;
    cursor: pointer;
    text-decoration: unset;
  }

  &__theme:hover {
    color: $blue64;
  }

  &__info {
    margin-top: 8px;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;

    color: $grey40;
  }
}

.email {
  align-items: flex-start;
  max-width: 600px;

  .message-container {
    width: 552px;
  }
}

.message-container {
  padding: 8px;
  background: $grey8;
  border: 1px solid $black-20;
  box-sizing: border-box;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  font-size: 15px;
  line-height: 24px;
}

.message-attachment {
  margin-top: 8px;
  width: 100%;
}

.message {
  align-items: flex-start;
  max-width: 400px;
  min-width: 200px;
}
</style>
